
      export const versions = {
        commit: 'a3a776b000602647674b49df40a71902e895d48a',
        branch: 'HEAD'
      };
